import { useTranslation } from 'react-i18next';
import { Icon } from '../regureStyles';

const InfoBanner = () => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        background: '#fffbeb',
        border: '1px solid #fde68a',
        borderRadius: 10,
        padding: '12px 18px',
        marginBottom: 24,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
      }}
    >
      <Icon name='alert-circle' size={18} color='#d97706' />
      <span style={{ fontSize: 13, color: '#92400e' }}>
        {t('screens.unmatchedDocs.infoNotice')}
      </span>
    </div>
  );
};

export default InfoBanner;
